import { useState, useEffect } from 'react'

// Hook detect mobile dựa trên screen width
// Dùng để render mobile-optimized UI (ẩn cột, ẩn dots, v.v.)
export const useIsMobile = (breakpoint = 640) => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < breakpoint)

  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < breakpoint)
    window.addEventListener('resize', handler)
    return () => window.removeEventListener('resize', handler)
  }, [breakpoint])

  return isMobile
}
